import { gql } from 'graphql-request';

import { useLocation, useParams } from 'react-router-dom';
import { graphqlRequest } from 'src/app/graphqlClient';

interface IUseEventCountInteger {
    eventType: string;
    needCummulation: boolean;
    incrementBy?: number;
}
interface IUseEventCountBoolean {
    eventType: string;
    count: number;
}
export const useUserEventCount = () => {
    const { bomId } = useParams();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tab = params?.get('tab');

    function pushUserEventCount({ eventType, needCummulation, incrementBy = 1 }: IUseEventCountInteger) {
        let eventName = eventType;
        if (needCummulation) {
            eventName = eventType + '_bom_tab';
            switch (tab) {
                case 'pricingAndLeadtime':
                    eventName = eventType + '_p&lt_tab';
                    break;
                case 'dataSheets':
                    eventName = eventType + '_datasheets_tab';
                    break;
                case 'documents':
                    eventName = eventType + '_additional_documents_tab';
                    break;
            }
        }
        try {
            const upsertMutationString = gql`
                mutation UpsertUserEventCount($count: Int!, $name: name!, $bomId: Int!) {
                    events_db{
                        insert_user_event_count(objects: {count: 0, name: $name, bom_id: $bomId}, on_conflict: {constraint: user_event_count_pkey, update_columns: []}) {
                            affected_rows
                        }
                        update_user_event_count(where: {name: { _eq: $name }, bom_id: { _eq: $bomId } }, _inc: { count: $count }) {
                            affected_rows
                        }
                    }
                }
            `;
            const variables = {
                count: incrementBy,
                name: eventName,
                bomId: -1
            };
            graphqlRequest({ document: upsertMutationString, variables });
        } catch (e) {
            /* empty */
        }
    }

    function pushUserEventCountAtBOM({ eventType, count }: IUseEventCountBoolean) {
        try {
            const upsertMutationString = gql`
                mutation UpsertUserEventCountAtBOM($count: Int!, $name: name!, $bomId: Int!) {
                    events_db {
                        insert_user_event_count(objects: {count: $count, name: $name, bom_id: $bomId}, on_conflict: {constraint: user_event_count_pkey, update_columns: [count]}) {
                            affected_rows
                        }
                    }
                }
            `;
            const variables = {
                count: count,
                name: eventType,
                bomId: Number(bomId || 0)
            };
            graphqlRequest({ document: upsertMutationString, variables });
        } catch (e) {
            /* empty */
        }
    }

    return { pushUserEventCount, pushUserEventCountAtBOM };
};
